// reset-password.js
function resetPassword(){
  $('[data-reset-form]').removeClass('hidden');
  $('[data-form-title]').text('Reset password');
  $('[data-signin-form]').addClass('hidden');
}

// Check if reset form has errors or success messages
$(document).ready(function() {
  if ($('[data-reset-form]').find('.errors, .success').length > 0) {
    resetPassword();
  }
});
